import { ActorCardWebComponent } from './component/ActorCardWebComponent';

export { ActorCardWebComponent };
